import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { fetchRolesAPI } from '../../../services/users-service';


import { FETCH_ROLES, FETCH_ROLES_ERROR, FETCH_ROLES_START, FETCH_ROLES_SUCCESS } from '../../actions/common/rolesAction';

export function* getRoles() {
    try {
        yield put({ type: FETCH_ROLES_START })
        const response = yield call(fetchRolesAPI);
        if (response.success) {
            yield put({ type: FETCH_ROLES_SUCCESS, roles: response.data })
            localStorage.setItem("roles", JSON.stringify(response.data));
        } else {
            yield put({ type: FETCH_ROLES_ERROR, error: response.error })
            message.error('Failed to fetch roles!');
        }
    } catch (error) {
        yield put({ type: FETCH_ROLES_ERROR, error })
        message.error('Failed to fetch roles!');
    }
}

function* rolesWatcher() {
    yield takeLatest(FETCH_ROLES, getRoles)
}

export default function* rootSaga() {
    yield all([
        rolesWatcher(),
    ]);
}